import * as React from "react";
import { Input } from "antd";
import { numberRegex } from "../data/constants";
import { phonePrefix } from "../data/country";

type PhoneInputType = {
    value: string,
    onChange: (value: string) => void,
    label?: string,
    error?: boolean,
    style?: React.CSSProperties,
    [key: string]: any,
}

const PhoneInput = ({value, onChange, error, label, style, ...rest}: PhoneInputType) => {
    const prefix = `(${phonePrefix})`;
    const parseValue = (val: string) => {
        if (!val) return prefix;
        const parts = val.split("");
        let v = prefix;
        for (let i = 0; i < parts.length; i++) {
            if (i === 0 || i === 2 || i === 5 || i === 7) {
                v += " ";
            }
            v += parts[i];
        }
        return v;
    }

    return <Input
        style={{ width: '50%', ...style }}
        placeholder={label || "Phone Number"}
        name={"phoneNumber"}
        status={error ? 'error' : undefined}
        value={parseValue(value || '')}
        onChange={(e) => {
            let inputVal = e.target.value;
            inputVal = inputVal.replace(prefix, "");
            inputVal = inputVal.replaceAll(" ", "").trim();
            const validValue = inputVal === "" || numberRegex.test(inputVal);
            if (validValue && inputVal.length <= 9) {
                onChange(inputVal);
            }
        }}
        {...rest}
    />
}

export default PhoneInput;